var map = {
	"./b-arrow.svg": 9145,
	"./card.svg": 1057,
	"./close.svg": 1169,
	"./closefull.svg": 522,
	"./community.svg": 4090,
	"./course.svg": 1350,
	"./dashboard.svg": 8413,
	"./delete.svg": 7537,
	"./edit.svg": 9692,
	"./example.svg": 457,
	"./eye-open.svg": 9290,
	"./eye.svg": 7223,
	"./form.svg": 533,
	"./full.svg": 7555,
	"./hidden_menu.svg": 6312,
	"./income.svg": 3483,
	"./language.svg": 8331,
	"./link.svg": 3803,
	"./message.svg": 9876,
	"./nested.svg": 1194,
	"./password.svg": 5055,
	"./search.svg": 8236,
	"./share.svg": 3739,
	"./show_menu.svg": 781,
	"./student.svg": 5046,
	"./table.svg": 9581,
	"./tree.svg": 892,
	"./user.svg": 9814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;